import { gql } from 'apollo-boost';

export const clientMobileAppsQuery = gql`
    query ClientMobileAppsQuery($login: String!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            access {
                canViewMobileApps
                canEditMobileApps
                canEditMobileAppDomain
                canViewMobileAppDomain
            }
        }
    }
`;
